import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import './footer.css'

const Footer = () => (

  <div className="footer">
    <p>Registered charity number 1158465. Company registration number 08340937. <OutboundLink href="/JBVC_Privacy_Policy_May_2018.pdf" target='_blank'>Privacy Policy</OutboundLink></p>
  </div>

)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js